<template>
  <div>
    <dt>{{ label }}</dt>
    <dd>{{ periodosOption[value] }}</dd>
  </div>
</template>

<script>
import CursoService from "../../../../domain/corpore/CursoService";
import CampoEnum from "../../../../domain/protocolo/CampoEnum";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "view-c-protocolo-periodo",
  props: {
    label: String,
    value: String
  },
  data() {
    return {
      periodosOption: {
        "1": `1° Período`,
        "2": `2° Período`,
        "3": `3° Período`,
        "4": `4° Período`,
        "5": `5° Período`,
        "6": `6° Período`,
        "7": `7° Período`,
        "8": `8 Período`,
        "9": `9° Período`,
        "10": `10° Período`,
        "11": `11° Período`,
        "12": `12° Período`
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/Periodo.vue